import React, {
  createContext,
  useContext,
  useState,
  useMemo,
  useCallback,
} from "react";

const SidebarContext = createContext(undefined);

export function SidebarProvider({ children }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [expandedItem, setExpandedItem] = useState(null);

  const toggleSidebar = useCallback((newOpen) => {
    setIsSidebarOpen(newOpen);
  }, []);

  const toggleItemExpansion = useCallback((itemTitle) => {
    if (!itemTitle) return;
    setExpandedItem((prev) => (prev === itemTitle ? null : itemTitle))
  }, []);

  const value = useMemo(() => ({
    isSidebarOpen,
    toggleSidebar,
    expandedItem,
    toggleItemExpansion,
  }), [isSidebarOpen, toggleSidebar, expandedItem, toggleItemExpansion]);

  return (
    <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
  );
}

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error("useSidebar must be used within a SidebarProvider");
  }
  return context;
};
